// Standard-atmosphere formulas as used by the US National Weather Service.

/** Station pressure, Pa, from an altimeter setting (Pa) and the station elevation (m). */
export function stationPressureFromAltimeter(altimeter: number, elevation: number): number {
  const hPa = (altimeter / 100) ** 0.190263 - 8.417286e-5 * elevation;
  return 100 * hPa ** (1 / 0.190263);
}

/** Altimeter setting, Pa, from station pressure (Pa) and the station elevation (m). */
export function altimeterFromStationPressure(pressure: number, elevation: number): number {
  const hPa = (pressure / 100) ** 0.190263 + 8.417286e-5 * elevation;
  return 100 * hPa ** (1 / 0.190263);
}

/** Saturation vapour pressure over water, Pa (Magnus formula). */
const vapourPressure = (dewPointC: number) => 611.2 * Math.exp((17.67 * dewPointC) / (dewPointC + 243.5));

/**
 * Density altitude, m: the height in the standard atmosphere with the same air density.
 * Humidity (from the dew point, if known) lowers the density through the virtual temperature.
 */
export function densityAltitude(pressure: number, tempC: number, dewPointC: number | null): number {
  const t = tempC + 273.15;
  const e = dewPointC === null ? 0 : vapourPressure(dewPointC);
  const virtualT = t / (1 - (e / pressure) * (1 - 0.622));
  const density = pressure / (287.05 * virtualT);
  return 44330.8 - 42266.5 * density ** 0.234969;
}
